import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ICON_SIZE } from '@/checkout-instore-legacy/constants/SizeConstants'
import COLORS from '@/checkout-instore-legacy/constants/Colors'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import ToolbarOption from '@/checkout-instore-legacy/components/Commons/Elements/ToolbarOption'
import { maskDocument } from '@/checkout-instore-legacy/utils/DocumentUtils'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

export default function PaymentToolbar({
  document,
  documentType,
  hasCoupon,
  onClickDocument,
  onClickCoupon,
  onClickGiftCard,
  onShareClick,
}) {
  const { socialShare } = getInstoreConfig()

  return (
    <div
      className="flex items-center bb b--black-20 ph5 ph0-ns pv2 pv3-ns"
      style={{ color: COLORS.ON_BASE_GRAY }}
    >
      {!!socialShare && (
        <div className="flex flex-auto flex-none-l justify-center justify-left-l ph5-l">
          <ToolbarOption
            id="shareShow"
            iconType="nc-share-26"
            onClick={onShareClick}
          >
            <FormattedMessage id="shareToolbar" />
          </ToolbarOption>
        </div>
      )}
      <div className="flex flex-auto flex-none-l justify-center justify-left-l ph5-l">
        <ToolbarOption
          id="couponShow"
          icon="fa-ticket"
          isEmpty={!hasCoupon}
          onClick={onClickCoupon}
        >
          <FormattedMessage id="cartCoupon" />
        </ToolbarOption>
      </div>
      <div className="flex flex-auto flex-none-l justify-center justify-left-l ph5-l">
        <ToolbarOption
          id="newGiftCardShow"
          icon={
            <Icon type="nc-gift-card" color="currentColor" size={ICON_SIZE} />
          }
          onClick={onClickGiftCard}
        >
          <FormattedMessage id="giftCardModalTitle" />
        </ToolbarOption>
      </div>
      <div className="flex flex-auto flex-none-l justify-center justify-left-l ph5-l">
        <ToolbarOption
          id="addDocument"
          icon="fa-id-card-o"
          isEmpty={!document}
          onClick={onClickDocument}
        >
          {document ? (
            maskDocument({ documentNumber: document, documentType })
          ) : (
            <FormattedMessage id="cpfOnFiscalNote" />
          )}
        </ToolbarOption>
      </div>
    </div>
  )
}

PaymentToolbar.propTypes = {
  document: PropTypes.string,
  documentType: PropTypes.string,
  hasCoupon: PropTypes.bool,
  onClickDocument: PropTypes.func,
  onClickCoupon: PropTypes.func,
  onClickGiftCard: PropTypes.func,
  onShareClick: PropTypes.func,
}
